import { TwMainColor } from "data/types";
import React, { FC, ReactNode } from "react";
import { Link } from "react-router-dom";
import { productCategory } from "types/productCategory";

export interface BadgeProps {
	className?: string;
	type: ReactNode;
	color?: TwMainColor;
	href?: string;
}

const Badge: FC<any> = ({
	className = "relative",
	type,
	color = "blue",
	href,
}) => {

	let label = (productCategory.find ((item: any) => item.key === type)).label
	let splitLabel = label.split("[SELF]");

	if (splitLabel.length > 1) {
		splitLabel[1] = "[SELF]";
	}



	const getType = (_type: string) => {
		
		let label = (productCategory.find ((item: any) => item.key === _type)).label;

		let splitLabel = label.split("[SELF]");

		return splitLabel[0];
	};
	
	const getColorClass = (hasHover = true) => {
		switch (color) {
		case "pink":
			return `text-pink-800 bg-pink-100 ${
			hasHover ? "hover:bg-pink-800" : ""
			}`;
		case "red":
			return `text-red-800 bg-red-100 ${hasHover ? "hover:bg-red-800" : ""}`;
		case "gray":
			return `text-gray-800 bg-gray-100 ${
			hasHover ? "hover:bg-gray-800" : ""
			}`;
		case "green":
			return `text-green-800 bg-green-100 ${
			hasHover ? "hover:bg-green-800" : ""
			}`;
		case "purple":
			return `text-purple-800 bg-purple-100 ${
			hasHover ? "hover:bg-purple-800" : ""
			}`;
		case "indigo":
			return `text-indigo-800 bg-indigo-100 ${
			hasHover ? "hover:bg-indigo-800" : ""
			}`;
		case "yellow":
			return `text-yellow-800 bg-yellow-100 ${
			hasHover ? "hover:bg-yellow-800" : ""
			}`;
		case "blue":
			return `text-blue-800 bg-blue-100 ${
			hasHover ? "hover:bg-blue-800" : ""
			}`;
		default:
			return `text-pink-800 bg-pink-100 ${
			hasHover ? "hover:bg-pink-800" : ""
			}`;
		}
	};

	const CLASSES =
		"nc-Badge inline-flex px-2 py-[1px] rounded-full " +
		className;
		
	return !!href ? (
		<Link
			to={href || ""}
			className={`transition-colors hover:text-white duration-300 ${CLASSES} ${getColorClass()}`}
			style={{fontWeight: "500"}}
		>
			<span 
				className={`text-[0.75rem]`}
				style={{fontWeight: "500"}}
			>
				#{splitLabel[0]}
			</span>
			<span 
				className={`text-[0.6rem]`}
				style={{fontWeight: "500"}}
			>
				{splitLabel[1]}
			</span>
		</Link>
	) : (
		<span
		className={`${CLASSES} ${getColorClass(false)} ${className}`}
				style={{fontWeight: "500"}}
		>
			<span 
				className={`text-[0.75rem]`}
				style={{fontWeight: "500"}}
			>
				#{splitLabel[0]}
			</span>
			<span 
				className={`text-[0.6rem]`}
				style={{fontWeight: "500"}}
			>
				{splitLabel[1]}
			</span>
		</span>
	);
};

export default Badge;
